import { useContext } from 'react'
import { number, bool, string } from 'prop-types'
import { StackView, Typography } from '@telus-uds/components-web'
import { isEmpty, isNil } from 'ramda'
import localeContext from '../../../../contexts/Locale'
import useTranslate from '../../../../hooks/useTranslate'
import { FinalPriceContainer } from './styles'
import { formatCurrency } from '../../../../utils/currency'

const FinalPrice = ({ price, isMonthly, overrideLabelPath, shouldMaskPrice }) => {
  if (isEmpty(price) || isNil(price)) return null

  const translate = useTranslate()
  const { lang } = useContext(localeContext)

  const getLabelPath = () => {
    let label
    if (overrideLabelPath) {
      // eslint-disable-next-line no-return-assign
      return (label = `${overrideLabelPath}`)
    }

    label = isMonthly ? 'priceBreakdown.dueMonthlyLabel' : 'priceBreakdown.dueTodayLabel'
    return label
  }

  const translatePath = getLabelPath()
  const suffix = isMonthly ? '/mo.' : ''

  return (
    <FinalPriceContainer>
      <StackView
        direction="row"
        tokens={{ justifyContent: 'space-between' }}
        testID={`final-price-${translatePath}`}
      >
        <Typography variant={{ bold: true }}>{translate(translatePath)}</Typography>
        <Typography
          variant={{ bold: true }}
          dataSet={{
            'di-mask': shouldMaskPrice
          }}
        >
          {formatCurrency(price, lang)}
          {suffix}
        </Typography>
      </StackView>
    </FinalPriceContainer>
  )
}

export default FinalPrice

FinalPrice.propTypes = {
  price: number,
  isMonthly: bool,
  overrideLabelPath: string,
  shouldMaskPrice: bool
}

FinalPrice.defaultProps = {
  price: null,
  overrideLabelPath: undefined,
  isMonthly: false,
  shouldMaskPrice: null
}
